import { CardinalDirection } from "../types/Enums";

/**
 * Ordered array of cardinal directions in clockwise order starting from North
 * This ensures consistent ordering across the application
 */
export const ORDERED_CARDINAL_DIRECTIONS: CardinalDirection[] = [
    CardinalDirection.North,
    CardinalDirection.NorthEast,
    CardinalDirection.East,
    CardinalDirection.SouthEast,
    CardinalDirection.South,
    CardinalDirection.SouthWest,
    CardinalDirection.West,
    CardinalDirection.NorthWest
];

/**
 * Get the sort order for cardinal directions
 * Components are sorted in clockwise order starting from North
 * Components without cardinal direction come last
 * 
 * @param direction The cardinal direction to get the sort order for
 * @returns A numeric sort order (0-7 for valid directions, 999 for null/undefined)
 */
export const getCardinalDirectionOrder = (direction: CardinalDirection | null | undefined): number => {
    if (!direction) return 999; // Components without cardinal direction come last
    
    const order: { [key in CardinalDirection]: number } = {
        [CardinalDirection.North]: 0,
        [CardinalDirection.NorthEast]: 1,
        [CardinalDirection.East]: 2,
        [CardinalDirection.SouthEast]: 3,
        [CardinalDirection.South]: 4,
        [CardinalDirection.SouthWest]: 5,
        [CardinalDirection.West]: 6,
        [CardinalDirection.NorthWest]: 7
    };
    
    return order[direction] ?? 999;
};

